export default "__VITE_ASSET__bnGJZYCY__"